import {useState} from 'react'
import axios from 'axios';
import { myURL } from '../assets/enviroment';
import imgLogo from '../assets/logoMiniso123.jpg';
import { Spinner } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { BiHome } from 'react-icons/bi';
import TableClientesFechas from '../Components/TableClientesFechas';
import DataConsultFechas from '../Components/DataConsultFechas';
import FormFechas from '../Components/FormFechas';

const initDataFechas = {
  fechaInicial: "",
  fechaFinal: "",
};

const MonitorClients = () => {
  const [dataFechas, setDataFechas] = useState(initDataFechas);
  const [dataClientes, setDataClientes] = useState([]);
  const [loading, setLoading] = useState(false);
  const [isError, setIsError] = useState("");

  const consultVentas = async () => {
    const { fechaInicial, fechaFinal } = dataFechas;
    try {
      console.log("dataFechas:...", dataFechas);
      setLoading(true);
      let tempDataClientes = {};
      const resCustomersBigQuery = await axios.get(
        `${myURL}getCustomersInBigQuery/${fechaInicial}/${fechaFinal}`
      );
      const dataCustomersBigQuery = resCustomersBigQuery.data;
      const resTransactionsBigQuery = await axios.get(
        `${myURL}getTransactionsInBigQuery/${fechaInicial}/${fechaFinal}`
      );
      const dataTransactionsBigQuery = resTransactionsBigQuery.data;
      const resCustomersAOM = await axios.get(
        `${myURL}getCustomersInAOM/${fechaInicial}/${fechaFinal}`
      );
      const dataCustomersAOM = resCustomersAOM.data;
      const resTransactionsAOM = await axios.get(
        `${myURL}getTransactionsInAOM/${fechaInicial}/${fechaFinal}`
      );
      const dataTransactionsAOM = resTransactionsAOM.data;
      tempDataClientes = {
        dataCustomersBigQuery,
        dataTransactionsBigQuery,
        dataCustomersAOM,
        dataTransactionsAOM,
      };
      console.log("tempDataClientes:...", tempDataClientes);
      setDataClientes([tempDataClientes]);
    } catch (error) {
      setIsError("Error en la consulta");
      console.log("error:...", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <div className="d-flex justify-content-center align-items-center gap-2">
        <img
          style={{ width: "50px" }}
          className="mt-1"
          src={imgLogo}
          alt="imgLogo"
        />
        <h2 className="text-center text-secondary">Monitoreo Clientes</h2>
      </div>
      <div className="d-flex justify-content-end">
        <Link to="/monitor" className="">
          <BiHome className="text-secondary me-3" size="2em" />
        </Link>
      </div>
      <div className="row">
        <div className="col-12 col-md-6 ">
          <FormFechas dataFechas={dataFechas} setDataFechas={setDataFechas} />
        </div>
        <div className="col-12 col-md-6 d-flex justify-content-start align-items-center">
          <DataConsultFechas
            fechaInicial={dataFechas.fechaInicial}
            fechaFinal={dataFechas.fechaFinal}
          />
        </div>
      </div>

      <button
        disabled={
          loading ||
          dataFechas.fechaInicial === "" ||
          dataFechas.fechaFinal === ""
        }
        onClick={consultVentas}
        className="btn btn-primary d-block me-auto ms-auto w-25 my-3"
      >
        {loading ? (
          <Spinner animation="border" variant="light" />
        ) : (
          "Realizar Consulta"
        )}
      </button>
      {isError && (
        <div className="fs-6 opacity-75 text-danger text-center me-auto ms-auto">
          {isError}
        </div>
      )}
      {dataClientes.length > 0 && (
        <TableClientesFechas dataClients={dataClientes} />
      )}
    </>
  );
};

export default MonitorClients